import { Link } from 'react-router-dom'
import Logo from '../components/Logo'

export default function Privacy() {
  return (
    <div className="min-h-[100dvh] px-6 py-12" style={{ background: 'var(--fp-bg)', color: 'var(--fp-text)' }}>
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-10">
          <Logo size="md" />
        </div>

        <h1 className="text-3xl font-bold mb-2" style={{ fontFamily: 'var(--fp-font-heading)' }}>Privacy Policy</h1>
        <p className="text-sm mb-8" style={{ color: 'var(--fp-text-muted)' }}>Last updated: 6 April 2026</p>

        <div className="space-y-6 text-sm leading-relaxed" style={{ color: 'var(--fp-text-muted)' }}>
          <section>
            <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--fp-text)' }}>1. Introduction</h2>
            <p>
              FlickPick ("we", "us", "our") operates the FlickPick web application at flickpick.com.au.
              This Privacy Policy explains how we collect, use, and protect your personal information
              when you use our service.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--fp-text)' }}>2. Information We Collect</h2>
            <p className="mb-2">We collect the following information:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Account information:</strong> Your name, email address, and profile picture when you sign up or log in via Google or Facebook.</li>
              <li><strong>Usage data:</strong> Movies you add, rate, or pick within your groups.</li>
              <li><strong>Group data:</strong> Group memberships and group-related activity.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--fp-text)' }}>3. How We Use Your Information</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>To provide and maintain the FlickPick service.</li>
              <li>To authenticate your identity when you log in.</li>
              <li>To enable group features such as shared watchlists and movie picks.</li>
              <li>To display movie information and content warnings from third-party sources (TMDB, DoesTheDogDie).</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--fp-text)' }}>4. Third-Party Services</h2>
            <p className="mb-2">We use the following third-party services:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Supabase:</strong> Authentication and database hosting.</li>
              <li><strong>Google OAuth:</strong> Sign-in via your Google account.</li>
              <li><strong>Facebook Login:</strong> Sign-in via your Facebook account.</li>
              <li><strong>TMDB (The Movie Database):</strong> Movie metadata and images.</li>
              <li><strong>DoesTheDogDie.com:</strong> Content warnings and trigger information.</li>
              <li><strong>Cloudflare:</strong> Hosting and content delivery.</li>
              <li>
                <strong>Plausible Analytics:</strong> Anonymous, cookieless page-view and event analytics.
                No personal data, no IP logging, no cross-site tracking.{' '}
                <a
                  href="https://plausible.io/privacy-focused-web-analytics"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline"
                  style={{ color: 'var(--fp-red)' }}
                >
                  Plausible's privacy policy
                </a>.
              </li>
              <li>
                <strong>Sentry:</strong> Error monitoring. We capture stack traces of crashes
                so we can fix bugs. PII is scrubbed by default.
              </li>
            </ul>
            <p className="mt-2">
              Each of these services has their own privacy policies. We encourage you to review them.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--fp-text)' }}>5. Data Storage and Security</h2>
            <p>
              Your data is stored securely using Supabase's infrastructure with row-level security
              policies. We do not sell, rent, or share your personal information with third parties
              for marketing purposes.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--fp-text)' }}>6. Data Deletion</h2>
            <p>
              You may request deletion of your account and associated data at any time by
              contacting us at <a href="mailto:hello@findability.com.au" className="underline" style={{ color: 'var(--fp-red)' }}>hello@findability.com.au</a>.
              Upon request, we will delete your account and personal data within 30 days.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--fp-text)' }}>7. Cookies</h2>
            <p>
              FlickPick uses essential cookies and local storage for authentication sessions only.
              We do not use tracking cookies or third-party advertising cookies.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--fp-text)' }}>8. Children's Privacy</h2>
            <p>
              FlickPick is designed for family use. We do not knowingly collect personal
              information from children under 13 without parental consent. If you believe a
              child has provided us with personal information, please contact us.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--fp-text)' }}>9. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify users of any
              material changes by updating the "Last updated" date at the top of this page.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--fp-text)' }}>10. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us
              at <a href="mailto:hello@findability.com.au" className="underline" style={{ color: 'var(--fp-red)' }}>hello@findability.com.au</a>.
            </p>
          </section>
        </div>

        <div className="mt-12 text-center">
          <Link to="/login" className="text-sm underline" style={{ color: 'var(--fp-text-muted)' }}>
            &larr; Back to FlickPick
          </Link>
        </div>
      </div>
    </div>
  )
}
